import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          codeRepositoryName: Yup.string()
                                                                 .required('Required'),
                                          pipelineType: Yup.string()
                                                           .required('Required'),
                                          templateId: Yup.string().nullable(),
                                      });
